<template>
  <div class="home-page">
    <div class="button-group">
      <button
        class="app-button"
        :class="{ qfx: isQfxClient }"
        @click="$router.push('/qrCode')"
      >
        Scan QR
      </button>
      <button
        class="app-button"
        :class="{ qfx: isQfxClient }"
        @click="$router.push('/manual')"
      >
        Enter Manually
      </button>
      <button
        class="app-button"
        :class="{ qfx: isQfxClient }"
        @click="$router.push('/showtime')"
      >
        Showtimes
      </button>
      <!-- <button class="app-button logout" @click="onLogout">
        Logout
      </button> -->
    </div>
  </div>
</template>

<script>
export default {
  name: "Home",
  computed: {
    isQfxClient() {
      return window.localStorage.getItem("CLIENT_NAME").toLowerCase() === "qfx";
    }
  },
  methods: {
    onLogout() {
      window.localStorage.removeItem("JWT_TOKEN");
      window.localStorage.removeItem("USERCINEINFO");
      window.localStorage.clear();

      this.$cookie.delete("BRHSID");
      this.$router.push({ name: "login" });
    }
  }
};
</script>
<style scoped>
.home-page {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;
  text-align: center;
  background: #f9fafb;
}

.title {
  margin-bottom: 30px;
  font-size: 28px;
  font-weight: 600;
  color: #333;
}

.button-group {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.app-button {
  width: 220px;
  padding: 14px 20px;
  font-size: 18px;
  font-weight: 500;
  border-radius: 10px;
  border: none;
  background: #b3a9e1;
  color: black;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.app-button.qfx {
  background: #0384b4 !important;
  color: #fff;
}

.app-button:hover {
  background: #76c2e1;
  transform: translateY(-2px);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
}

.app-button.logout {
  background: #ef4444;
}

.app-button.logout:hover {
  background: #dc2626;
}
</style>



// WEBPACK FOOTER //
// src/components/home.vue